import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./layout";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import ImportWallet from "./pages/ImportWallet";
import CreateWallet from "./pages/CreateWallet";

export function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Layout />}>
					<Route index element={<Home />} />
					<Route path="create-wallet" element={<CreateWallet />} />
					<Route path="import-wallet" element={<ImportWallet />} />
					<Route path="dashboard" element={<Dashboard />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
